import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Common Checkbox/Radio component
 *
 * @param {any} {
 *   @param {string}  checkClassName        classes applied to <Check> component
 *   @param {any}     children              child elements of <Check.Input> component
 *   @param {string}  id                    id selector of <Check.Input> and for of corresponding <Check.Label>
 *   @param {string}  inputClassName        classes applied to <Check.Input> component
 *   @param {string}  inputRef              ref of <Check.Input> component
 *   @param {bool}    isChecked             is checkbox/radio checked
 *   @param {boolean} isDisabled            is checkbox/radio disabled
 *   @param {string}  key                   key of parent <Check> component
 *   @param {string}  labelClassName        classes applied to <Check.Label> component
 *   @param {string}  labelAction           data-action attribute of <Check.Label> component
 *   @param {string}  name                  name of <Check.Input> component
 *   @param {any}     onClick               external handler function
 *   @param {string}  type                  type of input ('checkbox' | 'radio')
 *   @param {string}  value                 value of <Check.Input> component
 * }
 * @returns {JSX.Element}
 */
export const Checkbox = ({
  checkClassName = '',
  children = null,
  id,
  inputClassName = '',
  inputRef,
  isChecked,
  isDisabled,
  key,
  labelClassName = '',
  labelAction,
  name,
  onChange = () => {},
  onClick = () => {},
  type = 'checkbox', // must be 'checkbox' | 'radio'
  value,
  ...props
} = {}) => {
  return (
    <Form.Check className={checkClassName} key={key}>
      <Form.Check.Label className={labelClassName} data-action={labelAction} htmlFor={id}>
        <Form.Check.Input
          // data-* attributes get applied via props
          {...props}
          checked={isChecked}
          className={inputClassName}
          disabled={isDisabled}
          id={id}
          ref={inputRef}
          name={name}
          onChange={onChange}
          onClick={onClick}
          type={type}
          value={value}
        />
        <i className="input-helper" />
        {children}
      </Form.Check.Label>
    </Form.Check>
  );
};

Checkbox.propTypes = {
  checkClassName: PropTypes.string,
  children: PropTypes.any,
  id: PropTypes.string,
  inputClassName: PropTypes.string,
  inputRef: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  key: PropTypes.string,
  labelClassName: PropTypes.string,
  labelAction: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string,
};
